import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API_URL } from "../../env";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import TypeCase from "../../Helpers/TypeCase";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataFG } from "../../Redux/MastersData/DesignMasterDataSlice";

// ------------------------------------------------

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import InfoIcon from '@mui/icons-material/Info';
import Chip from "@mui/material/Chip";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import noData from "../../Images/nodata.png";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import DeleteDialog from "../../../src/Components/Dialog/DeleteDialog";
import PasswordDialog from "../../../src/Components/Dialog/PasswordDialog";
import RowPages from "../../../src/Components/RowPages/RowPages";

const CustomizedTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#e6e7eb',
    color: '#2c2d2e',
    maxWidth: 500,
    border: "1px solid #3e3f40",
    marginRight: "30px"
  },
}));

const DataTableWithPagination = ({
  // data,
  // status,
  // statusS,
  // fetchData,
  data,
  totalRecords,
  status,
  statusS,
  page,
  rowsPerPage,
  searchQuery,
  onPageChange,
  onRowsPerPageChange,
  onSearchChange,
}) => {
  const [shouldReRender, setShouldReRender] = useState(false);
  const Theme = useSelector((state) => state.Theme);
  const PermitData = useSelector((state) => state.PermitData);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const Message = location.state;

  const [Loader, setLoader] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const StyledTypography = styled(Typography)(({ theme }) => ({
    "&": {
      background: Theme.primaryThemeColor,
      color: "#fff",
      borderRadius: "25px",
      padding: " 0 5px 0 5px",
      marginTop: "2px",
      border: "2px solid white",
      fontWeight: 600,
      "@media (max-width: 768px)": {
        fontSize: "10px",
      },
    },
  }));

  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(30);

  // const [searchQuery, setSearchQuery] = useState("");
  // const totalPages = Math.ceil(data?.length / rowsPerPage);
  // const startIndex = (page - 1) * rowsPerPage;
  // const endIndex = startIndex + rowsPerPage;


  // const totalPages = Math.ceil(totalRecords / rowsPerPage);
  // const filteredData = data?.filter((row) => {
  //   return (
  //     row.supply_design?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.product_name?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.design_group?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.product?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.material?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.pattern?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
  //     row.department?.toLowerCase().includes(searchQuery?.toLowerCase())
  //   );
  // });

  // const paginatedData = filteredData?.slice(startIndex, endIndex);
  const paginatedData = data || [];
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  // const handleSearchChange = (e) => {
  //   setSearchQuery(e.target.value);
  //   setPage(1);
  // };


  // const handlePageChange = (event, value) => {
  //   setPage(value);
  // };
  // const handlePageChange = (event, value) => {
  //   setPage(value);

  //   dispatch(
  //     fetchDataFG({
  //       cmpdetail,
  //       UserDetail,
  //       page: value,
  //       rowsPerPage: rowsPerPage,
  //       searchQuery: searchQuery,
  //     })
  //   );
  // };
  // const handleChangeRowsPerPage = (value) => {
  //   setRowsPerPage(value);
  // };

  const hexToRGBFade = (hex, fade) => {
    hex = hex.replace("#", "");
    // Parse the red, green, and blue components from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGB value
    return `rgb(${r}, ${g}, ${b}, ${fade})`;
  };

  const handleDownloadCSV = () => {
    const csvData =
      "Supply Design,Design Code,Design Group,Product,Material,Pattern,Department\n" +
      data
        ?.map((row) => {
          return `"${row.supply_design}","${row.product_name}","${row.design_group}","${row.product}","${row.material}","${row.pattern}","${row.department}"`;
        })
        .join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "FGDesign_Master.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const tooltipRef = useRef(null);
  const [openTooltip, setOpenTooltip] = useState(data?.map(() => false) || []);

  const handleTooltipClose = () => {
    setOpenTooltip((pre) => pre?.map(() => false));
  };

  const handleTooltipOpen = (index) => {
    setOpenTooltip((pre) => pre?.map((item, ind) => index == ind ? !item : item));

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  useEffect(() => {
    setOpenTooltip(data?.map(() => false) || []);
  }, [data]);

  useEffect(() => {
    const handleClickAway = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setOpenTooltip((pre) => pre?.map(() => false));
      }
    };

    document.addEventListener('mousedown', handleClickAway);
    return () => {
      document.removeEventListener('mousedown', handleClickAway);
    };
  }, []);

  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [modalOpenPassword, setModalOpenPassword] = useState(false);

  const handleModalOpenDelete = () => {
    setModalOpenDelete(true);
  };
  const handleModalCloseDelete = () => {
    setModalOpenDelete(false);
  };

  const handleModalOpenPassword = () => {
    setModalOpenPassword(true);
  };
  const handleModalClosePassword = () => {
    setModalOpenPassword(false);
  };

  const removeDesign = async () => {
    //   setLoader(true);
    //   var myHeaders = new Headers();
    //   const Token = localStorage.getItem("token");
    //   myHeaders.append("Content-Type", "application/json");
    //   myHeaders.append("Access-Control-Allow-Origin", "*");
    //   myHeaders.append("Authorization", `Bearer ${Token}`);
    //   var raw = CustomStringify({
    //     Database: cmpdetail?.Database,
    //     Password: cmpdetail?.Password,
    //     Server: cmpdetail?.Server,
    //     User_ID: cmpdetail?.User_ID,
    //     Port: cmpdetail?.Port,
    //   });
    //   var requestOptions = {
    //     method: "POST",
    //     headers: myHeaders,
    //     body: raw,
    //     redirect: "follow",
    //   };
    //   fetch(`${API_URL}/FGDesignListDelete_ById?id=${deleteId}`, requestOptions)
    //     .then((response) => response.json())
    //     .then((result) => {
    //       if (result?.status == true) {
    //         handleModalCloseDelete();
    //         setLoader(false);
    //         showToast("Deleted Successfully", "success");
    //         dispatch(fetchData({ cmpdetail: cmpdetail, page: page, rowsPerPage: rowsPerPage, searchQuery: searchQuery }));
    //       } else {
    //         setLoader(false);
    //         showToast(result?.message, "error");
    //       }
    //     })
    //     .catch((error) => {
    //       setLoader(false);
    //       showToast("API Error", "error");
    //       console.log(error);
    //     });
  };

  const deleteDesign = (row) => {
    handleModalOpenDelete();
    setDeleteId(row?.Desg_ID);
  };

  useEffect(() => {
    const keyEnter = (event) => {
      if (event.altKey) {
        event.preventDefault();
        switch (event.key) {
          case "n":
            navigate("AddFGDesign");
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener("keydown", keyEnter);

    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  });

  useEffect(() => {
    if (Message) {
      showToast(Message, "success");
      navigate(location.pathname, { replace: true });
    }
  }, []);


  const Muitheme = useTheme();
  const isMobile = useMediaQuery(Muitheme.breakpoints.down("sm"));

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "500",
        fontSize: "20px",
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
      subtitle2: {
        "@media (max-width: 768px)": {
          display: "none"
        },
      }
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "28px",
            width: "25vw",
            minWidth: "100px",
            background: "#fff",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-12px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "13px",
            maxWidth: "260px",
            height: "28px",
            padding: "12px 8px 12px 8px",
            fontWeight: 500,
            "@media (max-width: 768px)": {
              fontSize: "11px",
              padding: "10px 5px 10px 5px",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #9a9da1",
          },
          head: {
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
              zIndex: -1,
            },
            whiteSpace: "nowrap",
            width: "auto",
            "@media (max-width: 768px)": {
              fontSize: "13px",
              padding: "2px 16px"
            },
          },
          body: {
            whiteSpace: "nowrap",
            width: "auto",
            "@media (max-width: 768px)": {
              fontSize: "13px",
              padding: "2px 16px"
            },
          },
        },
      },
    },
  });

  return (
    <>
      <div className="main-box">
        <ThemeProvider theme={theme}>
          <div className="box-head">
            <Stack alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(`/CompanyDashboard`);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h4">Designs/Styles</Typography>
              {totalRecords ? (
                <StyledTypography variant="caption">{totalRecords}</StyledTypography>
              ) : (
                <></>
              )}
            </Stack>
            <Stack alignItems="center" direction="row">
              {PermitData.result?.IsSearch === true ? (
                // <TextField
                //   id="Search"
                //   placeholder="Search"
                //   value={searchQuery}
                //   onChange={handleSearchChange}

                // />
                <TextField
                  id="Search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => onSearchChange(e.target.value)}
                />
              ) : null}
            </Stack>
            <Stack className="btns" alignItems="center" direction="row">
              {PermitData.result?.IsPrint === true ? (
                <>
                  <Button variant="contained" startIcon={<SaveAltIcon />} onClick={handleDownloadCSV}>
                    CSV
                  </Button>
                </>
              ) : (
                <></>
              )}
              {PermitData.result?.IsSave === true ? (
                <Button
                  variant="contained"
                  onClick={() => navigate("AddFGDesign")}
                >
                  + New
                </Button>
              ) : (
                <></>
              )}
            </Stack>
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: 9999 }}
            open={Loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <DeleteDialog
            modalOpen={modalOpenDelete}
            handleModalClose={() => handleModalCloseDelete()}
            executeConfirmed={() => handleModalOpenPassword()}
          />
          <PasswordDialog
            modalOpen={modalOpenPassword}
            handleModalClose={() => handleModalClosePassword()}
          // executeConfirmed={() => removeDesign()}
          />

          <div className="card-form-box master">
            {status == "loading" ? (
              <>
                <div
                  style={{
                    height: "100%",
                    display: "grid",
                    placeContent: "center",
                  }}
                >
                  <CircularProgress sx={{ ml: 1, mb: 1 }} />
                  <Typography variant="subtitle2">Loading...</Typography>
                </div>
              </>
            ) : (
              <>
                <Paper
                  sx={{
                    width: "100%", height: "100%", overflowY: "scroll",
                    "::-webkit-scrollbar": {
                      display: "none"
                    }
                  }}
                >
                  <TableContainer component={Paper} sx={{ height: "100%" }}>
                    {status == "failed" || statusS == false ? (
                      <>
                        <div className="d-flex justify-content-center">
                          <img src={noData} />
                        </div>
                      </>
                    ) : (
                      <>
                        <Table
                          stickyHeader
                          sx={{ minWidth: 650 }}
                          size="small"
                          aria-label="a dense table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Supply Design
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Design Code
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Design Group
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Product
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Material
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Pattern
                              </TableCell>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Department
                              </TableCell>
                              {/* <TableCell sx={{ fontWeight: 600 }}>
                                Status
                              </TableCell> */}
                              <TableCell
                                sx={{ fontWeight: 600 }}
                                align="center"
                              >
                                Action
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {paginatedData?.map((row, index) => {
                              return (
                                <TableRow hover key={index} sx={{ py: 0.5 }}>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.supply_design}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.product_name}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.design_group}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.product}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.material}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.pattern}
                                  </TableCell>
                                  <TableCell sx={{ py: 0.5 }}>
                                    {row.department}
                                  </TableCell>
                                  {/* <TableCell sx={{ py: 0.5 }}>
                                    {row?.in_active ? (
                                      <Chip
                                        label="DeActive"
                                        size="small"
                                        sx={{
                                          bgcolor: "#F55050",
                                          color: "#fff",
                                          fontSize: "10px",
                                        }}
                                      />
                                    ) : (
                                      <Chip
                                        label="Active"
                                        size="small"
                                        sx={{
                                          bgcolor: "#2EB086",
                                          color: "#fff",
                                          fontSize: "10px",
                                        }}
                                      />
                                    )}
                                  </TableCell> */}
                                  <TableCell align="center" sx={{ py: 0.5 }}>
                                    <Box
                                      display="flex"
                                      justifyContent="space-evenly"
                                    >
                                      {PermitData.result?.IsUpdate ===
                                        true ? (
                                        <>
                                          <IconButton
                                            color="primary"
                                            aria-label="Edit"
                                            onClick={() =>
                                              navigate(
                                                `EditFGDesign/${row.id}`
                                              )
                                            }
                                            sx={{ padding: 0, margin: 0 }}
                                          >
                                            <ModeEditOutlinedIcon sx={{ fontSize: "20px" }} />
                                          </IconButton>
                                        </>
                                      ) : (
                                        <IconButton
                                          disabled
                                          aria-label="edit"
                                          sx={{ padding: 0, margin: 0 }}
                                        >
                                          <ModeEditOutlinedIcon
                                            sx={{ fontSize: "20px" }}
                                          />
                                        </IconButton>
                                      )}
                                      {/* {PermitData.result?.IsDelete ===
                                        true ? (
                                        <>
                                          <IconButton
                                            color="primary"
                                            aria-label="Delete"
                                            onClick={() => deleteDesign(row)}
                                            sx={{ padding: 0, margin: 0 }}
                                          >
                                            <DeleteOutlineOutlinedIcon
                                              sx={{ fontSize: "20px" }}
                                            />
                                          </IconButton>
                                        </>
                                      ) : (
                                        <IconButton
                                          disabled
                                          aria-label="Delete"
                                          sx={{ padding: 0, margin: 0 }}
                                        >
                                          <DeleteOutlineOutlinedIcon
                                            sx={{ fontSize: "20px" }}
                                          />
                                        </IconButton>
                                      )} */}
                                      {/* {shouldReRender ? (
                                        <IconButton
                                          aria-label="info"
                                          sx={{ padding: 0, margin: 0 }}
                                        >
                                          <InfoIcon
                                            sx={{ fontSize: "20px", color: "#b2b4b8" }}
                                          />
                                        </IconButton>
                                      ) : null}
                                      {!shouldReRender && (
                                        <CustomizedTooltip
                                          onClose={handleTooltipClose}
                                          open={openTooltip[index]}
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          title={
                                            <>
                                              <Typography variant="overline" color="inherit">Creation Date: <b>{row.creation_date}</b></Typography><br />
                                              <Typography variant="overline" color="inherit">Update Date &nbsp;&nbsp;&nbsp;: <b>{row.LastUpdateDate}</b></Typography><br />
                                              <Typography variant="overline" color="inherit">Save User &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <b>{row.SaveUser}</b></Typography><br />
                                              <Typography variant="overline" color="inherit">Update User &nbsp;&nbsp;&nbsp;&nbsp;: <b>{row.UpdateUser}</b></Typography><br />
                                            </>
                                          }
                                        >
                                          <IconButton
                                            ref={tooltipRef}
                                            aria-label="edit"
                                            sx={{ padding: 0, margin: 0 }}
                                            onClick={() => handleTooltipOpen(index)}
                                          >
                                            <InfoIcon
                                              sx={{ fontSize: "20px", color: "#b2b4b8" }}
                                            />
                                          </IconButton>
                                        </CustomizedTooltip>
                                      )} */}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </>
                    )}
                  </TableContainer>
                </Paper>
              </>
            )}
          </div>
          <div className="pagination-box d-flex justify-content-end align-items-center">
            {/* <RowPages
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(value) => handleChangeRowsPerPage(value)}
              All={totalRecords}
            /> */}
            <RowPages
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={onRowsPerPageChange}
              All={totalRecords}
            />
            {/* <Pagination
              count={totalPages}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 1}
              onChange={handlePageChange}
              color="primary"
              size="small"
            /> */}
            <Pagination
              count={totalPages}
              page={page}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 1}
              onChange={onPageChange}
              color="primary"
              size="small"
            />
          </div>
        </ThemeProvider>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
};

// export default function TableData() {
//   const dispatch = useDispatch();
//   const { cmpdetail } = useSelector((state) => state.CompanyDetail);
//   const UserDetail = useSelector((state) => state.UserDetail);
//   const { result, status, error } = useSelector((state) => state.DesignMasterData);

//   console.log("Designs", result?.data)
//   console.log("Designs", UserDetail?.result)
//   useEffect(() => {
//     dispatch(fetchDataFG({ cmpdetail, UserDetail }));
//   }, []);

//   return (
//     <>
//       <DataTableWithPagination
//         data={result?.data}
//         status={status}
//         statusS={result?.success}
//         fetchData={fetchDataFG}
//       />
//     </>
//   );
// }

export default function TableData() {
  const dispatch = useDispatch();

  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);

  const { result, status, error } = useSelector((state) => state.DesignMasterData);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  // What user is currently typing
  const [searchQuery, setSearchQuery] = useState("");

  // Initial API call
  useEffect(() => {
    dispatch(
      fetchDataFG({
        cmpdetail,
        UserDetail,
        page: 1,
        rowsPerPage: 30,
        searchQuery: "",
      })
    );
  }, [dispatch, cmpdetail, UserDetail]);

  // DEBOUNCED SEARCH

  useEffect(() => {
    // Don't call API immediately when component loads
    // if (searchQuery === "") {
    //   return;
    // }

    const timer = setTimeout(() => {
      setPage(1);
      dispatch(
        fetchDataFG({
          cmpdetail,
          UserDetail,
          page: 1,
          rowsPerPage: rowsPerPage,
          searchQuery: searchQuery,
        })
      );
    }, 500); // 500ms debounce

    // Cancel previous timer when user types again
    return () => {
      clearTimeout(timer);
    };

  }, [searchQuery]);


  // SEARCH CHANGE

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    setPage(1);
  };

  // PAGINATION

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(fetchDataFG({
      cmpdetail,
      UserDetail,
      page: value,
      rowsPerPage: rowsPerPage,
      searchQuery: searchQuery,
    })
    );
  };


  // ROWS PER PAGE

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setPage(1);
    dispatch(fetchDataFG({
      cmpdetail,
      UserDetail,
      page: 1,
      rowsPerPage: value,
      searchQuery: searchQuery,
    })
    );
  };


  return (
    <DataTableWithPagination
      data={result?.data || []}
      totalRecords={result?.totalRecords || 0}
      status={status}
      statusS={result?.success}
      page={page}
      rowsPerPage={rowsPerPage}
      searchQuery={searchQuery}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      onSearchChange={handleSearchChange}
    />
  );
}